import type { List } from '../lists/list'

export class Board {
    boardId: string
    label: string
    position: number
    lists: List[]
}
